import { useEffect } from 'react'
import { Grid } from '@mui/material'
import { ISettingsItem } from "../../../Settings"
import StepperDefault from '../../StepperDefault'
import { usePlan } from '../../../Plans'
import { useTranslation } from '../../../i18n'

export default function StepperPlan({ name, variables }: ISettingsItem) {
  const { step, updatePlanState } = usePlan()
  const { t } = useTranslation()
  const defaultTextArray = [
    t.page2.stepper.yourPlan,
    t.page2.stepper.info,
    t.page2.stepper.address,
    t.page2.stepper.paymentMethod,
    t.page2.stepper.payment,
  ]
  const { text = defaultTextArray } = variables || {}

  useEffect(() => {
    updatePlanState({ steps: defaultTextArray })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [t])

  return (
    <Grid item className={name ? `${name} stepper-plan step-${step + 1}` : `stepper-plan step-${step + 1}`}>
      <StepperDefault step={step} steps={text} />
    </Grid>
  )
}